import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseRecord from './baseRecord';
import reduxStore from '../../reduxStore';
export default function mixinReduxRecord(schema) {
  return /*#__PURE__*/function (_BaseRecord) {
    function ReduxRecord() {
      _classCallCheck(this, ReduxRecord);
      return _callSuper(this, ReduxRecord, arguments);
    }
    _inherits(ReduxRecord, _BaseRecord);
    return _createClass(ReduxRecord, [{
      key: "getState",
      value:
      // =====================
      // =====================
      // REDUX & RELATIONSHIPS
      // =====================
      // =====================

      function getState() {
        return reduxStore.getAppState();
      }
    }]);
  }(BaseRecord(schema));
}